// extracted by mini-css-extract-plugin
export default {"modal":"Modal3D_modal__Fjm+0"};